import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AgentIcon: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props}>
      <path d='M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 4L12 5.5L9 4L3 7V9H4.8L6 12L4.6 16L8.9 17.5L12 15.5L15.1 17.5L19.4 16L18 12L19.2 9H21ZM7.6 8.5C8.2 8.3 8.8 8.1 9.4 7.9L12 9.3L14.6 7.9C15.2 8.1 15.8 8.3 16.4 8.5L15.3 11.2L17 14.9L13.9 13.9L12 15.3L10.1 13.9L7 14.9L8.7 11.2L7.6 8.5Z' />
    </SvgIcon>
  );
};
